module.exports = __webpack_public_path__ + "static/img/College-Lawn.8163a42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/College-Lawn.jpg
// module id = 6iHE
// module chunks = 0